import { Switch } from "react-router-dom";

import DataSetRoutes from "routes/DataSetRoutes";
import NonPropertyRoutes from "routes/NonPropertyRoutes";
import PropertyRoutes from "routes/PropertyRoutes";
import RecordDetailRoutes from "routes/RecordDetailRoutes";
import { MarketingRoutes, MarketingHomeRoute } from "routes/MarketingRoutes";

function Routes() {
	return (
		<Switch>
			{MarketingRoutes()}
			{RecordDetailRoutes()}
			{DataSetRoutes()}
			{PropertyRoutes()}
			{NonPropertyRoutes()}
			{MarketingHomeRoute()}
		</Switch>
	);
}

export default Routes;
